/* src/app/components/PaperHeader/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

import styles from './styles';

const PaperHeader = ({ classes, text, children, noPadding }) => (
  <div className={classNames(classes.container, { [classes.noPadding]: noPadding })}>
    <Typography variant="title">{text}</Typography>
    {children}
  </div>
);

PaperHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  text: PropTypes.string.isRequired,
  noPadding: PropTypes.bool,
  children: PropTypes.any,
};

PaperHeader.defaultProps = {
  noPadding: false,
  children: null,
};

export default withStyles(styles)(PaperHeader);



// WEBPACK FOOTER //
// ./src/app/components/PaperHeader/index.js